var exports = {
  "kL": "ChannelStickersArea.module__container___ZGp3bV",
  "gI": "ChannelStickersArea.module__standalone___ZGp3bV",
  "Qs": "ChannelStickersArea.module__content___ZGp3bV",
  "UV": "ChannelStickersArea.module__stickerPreview___ZGp3bV",
  "HF": "ChannelStickersArea.module__stickerImage___ZGp3bV",
  "od": "ChannelStickersArea.module__stickerInfo___ZGp3bV",
  "Zl": "ChannelStickersArea.module__stickerName___ZGp3bV",
  "Gl": "ChannelStickersArea.module__stickerDescription___ZGp3bV",
  "DT": "ChannelStickersArea.module__removeButton___ZGp3bV",
  "Kk": "ChannelStickersArea.module__icon___ZGp3bV",
};

module.exports = exports;
